export default __webpack_public_path__ + "static/media/au.178f4703.jpg";